import React from 'react';
import Container from 'react-bootstrap/Container';
import Image from 'react-bootstrap/Image';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Table from 'react-bootstrap/Table';
import Tabla from '../Tabla';
import MatchList from '../MatchList';
import MatchCardGroup from '../MatchCardGroup';
import Players from '../Players';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
class Apertura2014 extends React.Component {

  constructor(props){
    super(props);
        this.comeBack = this.comeBack.bind(this);
	this.handleChange = this.handleChange.bind(this);
	var id_list = [];
	for (var i = 802; i <= 823; i++) {
              if(i!==810 && i!==813 && i!==814 && i!==819 && i!==820){
        	id_list.push(i);
		}
        }
    this.state = {
	showCards: true,
      path: this.props.path,
      ctype: this.props.ctype,
	        kit_path: '/images/kits/todas/',
      kits: [],

      torneo: this.props.torneo,
      id_list: id_list,

	table2:[{'color':0,'shortname':'cobreloa', 'rivalName':'Cobreloa', 'pj':17, 'pg':3,'pe':2,'pp':12,'gf':19,'gc':39,'dif':-20, 'pts':11},
              {'color':0,'shortname':'audax', 'rivalName':'Audax Italiano', 'pj':17, 'pg':6,'pe':5,'pp':6,'gf':26,'gc':21,'dif':5, 'pts':23},
	     {'color':0,'shortname':'arica', 'rivalName':'San Marcos', 'pj':17, 'pg':5,'pe':3,'pp':9,'gf':12,'gc':21,'dif':-9, 'pts':18},
              {'color':0,'shortname':'iquique', 'rivalName':'Dep. Iquique', 'pj':17, 'pg':3,'pe':7,'pp':7,'gf':22,'gc':31,'dif':-9, 'pts':16},
	      {'color':0,'shortname':'udeconce', 'rivalName':'U. de Concepción', 'pj':17, 'pg':4,'pe':6,'pp':7,'gf':18,'gc':23,'dif':-5, 'pts':18},
              {'color':0,'shortname':'catolica', 'rivalName':'U. Católica', 'pj':17, 'pg':5,'pe':2,'pp':10,'gf':20,'gc':25,'dif':-5, 'pts':17},
              {'color':0,'shortname':'colocolo', 'rivalName':'Colo Colo', 'pj':17, 'pg':13,'pe':2,'pp':2,'gf':34,'gc':11,'dif':23, 'pts':41},
              {'color':0,'shortname':'cobresal', 'rivalName':'Cobresal', 'pj':17, 'pg':4,'pe':5,'pp':8,'gf':24,'gc':30,'dif':-6, 'pts':17},
              {'color':'#295e1e','shortname':'huachipato', 'rivalName':'Huachipato', 'pj':17, 'pg':8,'pe':2,'pp':7,'gf':30,'gc':25,'dif':5, 'pts':26},
              {'color':0,'shortname':'udechile', 'rivalName':'U. de Chile', 'pj':17, 'pg':14,'pe':2,'pp':1,'gf':37,'gc':13,'dif':24, 'pts':44},
              {'color':0,'shortname':'lacalera', 'rivalName':'U. La Calera', 'pj':17, 'pg':6,'pe':4,'pp':7,'gf':25,'gc':22,'dif':3, 'pts':22},
              {'color':0,'shortname':'antofagasta', 'rivalName':'Antofagasta', 'pj':17, 'pg':4,'pe':4,'pp':9,'gf':13,'gc':25,'dif':-12, 'pts':16},
              {'color':'#295e1e','shortname':'union', 'rivalName':'U. Española', 'pj':17, 'pg':8,'pe':1,'pp':8,'gf':22,'gc':24,'dif':-2, 'pts':25},
              {'color':0,'shortname':'ohiggins', 'rivalName':'O\'Higgins', 'pj':17, 'pg':6,'pe':5,'pp':6,'gf':27,'gc':25,'dif':2, 'pts':23},
	      {'color':0,'shortname':'barnechea', 'rivalName':'Barnechea', 'pj':17, 'pg':6,'pe':2,'pp':9,'gf':16,'gc':26,'dif':-10, 'pts':20},
	      {'color':0,'shortname':'nublense', 'rivalName':'Ñublense', 'pj':17, 'pg':5,'pe':4,'pp':8,'gf':21,'gc':29,'dif':-8, 'pts':19},
              {'color':'#295e1e','shortname':'palestino', 'rivalName':'Palestino', 'pj':17, 'pg':10,'pe':1,'pp':6,'gf':28,'gc':21,'dif':7, 'pts':31},
              {'color':'#295e1e','shortname':'wanderers', 'rivalName':'S. Wanderers', 'pj':17, 'pg':14,'pe':1,'pp':2,'gf':31,'gc':14,'dif':17, 'pts':43}]

    };
  }

  componentDidMount() {
	this.getKits();
		let newtable = this.sortTable(this.state.table2);
  		this.setState({table2:newtable});

	}

getKits(){

        fetch("https://www.registrosudec.com:5000/kits", {

    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      id_list: this.state.id_list
    })
    }).then(
                res => res.json()
                )
  .then(
    (result) => {
        console.log(result)
        this.setState({ 
        kits: result['kits']}) //[{path:"45.png", kit:yellow, short:"blue", socks:"blue", count:15, 
    },
    // Nota: es importante manejar errores aqu   y no en
    // un bloque catch() para que no interceptemos errores
    // de errores reales en los componentes.
    (error) => {
      console.log(error);
      this.setState({fecha: []})
    }
  );
}



  handleChange(val){
    console.log(val);
    if(val===1){
      this.setState({showCards:true});
    }
    else{
      this.setState({showCards:false});
    }
  }

comeBack(){
this.setState({path:this.state.path});
}

subText(color, text){

let comp = [];
comp.push(

	<Row className="justify-content-md-center">
            <Col lg={3} xl={3} >

        <Table bordered={ false } size="sm">
        <tr style={{border: 'none', textAlign: 'rigth' }}>
        <td bgcolor={color} style={{width:'20px'}}>
        </td>
        <td style={{border: 'none', textAlign: 'center'}}> {text} </td>
        </tr>
        </Table>
        </Col>
        </Row>



)
return comp;

}


sortTable(table){
       let aux;
      for(let i=table.length-1;i>0;i--){
             for(let j =0; j<i; j++){
                 if( (table[j].pts < table[j+1].pts) || 
                     ((table[j].pts === table[j+1].pts) && (table[j].dif < table[j+1].dif)) ||
                     ((table[j].pts === table[j+1].pts) && (table[j].dif === table[j+1].dif) && (table[j].gf < table[j+1].gf))){
			aux = table[j+1];
			table[j+1] = table[j];
                        table[j] = aux;
		} 
	     }		
	}
return table;

}


render(){


  let subT = this.subText('#295e1e', 'Clasificado a Liguilla');
  return(

	<div style={{textAlign: 'center' }}>

	                <div style={{ height: '50px' }}></div>
        <div className="mytitlepartidos">  Indumentaria UDEC Apertura 2014</div>
        <div style={{ height: '50px' }}></div> 

        <div style={{display: 'inline-block' }}>
        <table style={{textAlign: 'center' }}>
        <tr>
           {this.state.kits.map((i) => {
                   return ( <td> <Image  className="escudo-home" src={this.state.kit_path+i['path']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+i['short']+".png"}/> </td>)
            })}
        </tr>
        <tr>
        {this.state.kits.map((i) => {
                   return ( <td> <Image  className="myshort" src={this.state.kit_path+'socks-'+i['socks']+".png"}/> </td>)
            })}
        </tr>

        <tr>
                {this.state.kits.map((i) => {
                   return ( <td class="circle"> {i['count']} </td>)
            })}
        </tr>
        </table>
        </div>


	<div style={{ height: '50px' }}></div>
	<div className="mytitlepartidos"> Tabla General</div>
	<div style={{ height: '10px' }}></div>
        {<Tabla teams={this.state.table2} />}
        <div style={{ height: '10px' }}></div>
         {subT}
	 
	
	<div style={{ height: '100px' }}></div>
	<div className="mytitlepartidos">  Partidos UDEC Apertura 2014</div>
	<div style={{ height: '10px' }}></div>

	<ToggleButtonGroup type="radio" name="options" defaultValue={1} onChange={this.handleChange}>
            <ToggleButton variant="secondary" value={1}>Tarjetas</ToggleButton>
            <ToggleButton variant="secondary" value={2}>Listado</ToggleButton>
          </ToggleButtonGroup>
	 <div style={{ height: '10px' }}></div>
	<Container>
	<div className={this.state.showCards ? '': 'hiddenCard'}>
           <MatchCardGroup id_list={this.state.id_list}></MatchCardGroup>
         </div>
         <div className={this.state.showCards ? 'hiddenCard': ''}>

           <MatchList id_list={this.state.id_list} showName={true}></MatchList>

         </div>
	</Container>

	<div style={{ height: '100px' }}></div>
        <div className="mytitlepartidos">  Jugadores UDEC Apertura 2014</div>
        <div style={{ height: '10px' }}></div>

	<Players torneo="Apertura 2014" />
     </div>


  )
}

}
export default Apertura2014;
